import type { GameState } from "../types/game";

const STORAGE_KEY = "setback-web:quickPlay:v1";

type PersistShape = { v: 1; userUid: string; game: GameState };

function parse(json: unknown): GameState | null {
  if (!json || typeof json !== "object") return null;
  const o = json as Partial<PersistShape>;
  if (o.v !== 1 || typeof o.userUid !== "string" || !o.game || typeof o.game !== "object") {
    return null;
  }
  const game = o.game as GameState;
  if (
    !Array.isArray(game.players) ||
    game.players.length !== 4 ||
    game.players[0]?.uid !== o.userUid
  ) {
    return null;
  }
  const hand = game.currentHand;
  if (!hand || !Array.isArray(hand.hands) || hand.hands.length !== 4) return null;
  if (
    typeof game.seed !== "number" ||
    typeof game.scoreA !== "number" ||
    typeof game.scoreB !== "number"
  ) {
    return null;
  }
  return game;
}

export function loadQuickPlaySession(expectedUid: string): GameState | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return parse(JSON.parse(raw) as unknown);
  } catch {
    return null;
  }
}

export function saveQuickPlaySession(userUid: string, game: GameState): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    const payload: PersistShape = { v: 1, userUid, game };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* quota / private mode */
  }
}

export function clearQuickPlaySession(): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
